import { Table, TableBody, TableContainer } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  calculateEnergyCarbonFootprint,
  getEnergyResults,
} from '../../../calculators/carbon-footprint/energy-carbon-footprint-calculator'
import { CalculatedVersion } from '../../../calculators/use-calculator'
import { EmissionModel } from '../../../emission-coefficients/emission-coefficients'
import {
  PurchasedEnergyResultSubCategory,
  purchasedEnergySubCategories,
} from '../../../provider/result-categories'
import {
  formatLargeEmissionPerYear,
  largeEmissionPerYearUnit,
} from '../../../util/formatters'
import { ResultsTableHeaderRow } from '../../common/ResultsTableHeaderRow'
import { ResultsTableRow } from '../../common/ResultsTableRow'
import { useTableStyles } from '../../common/use-table-styles'

type Props = {
  versions: CalculatedVersion[]
  emissionModel: EmissionModel
}

export default function EnergyEmissionsTable({
  versions,
  emissionModel,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const classes = useTableStyles()

  const getValuesForFirstYear = (
    subCategories: PurchasedEnergyResultSubCategory[],
  ) =>
    getEnergyResults(
      versions,
      subCategories,
      (energies, { buildingYear }) =>
        calculateEnergyCarbonFootprint(energies, buildingYear),
      emissionModel,
    )

  return (
    <TableContainer>
      <Table className={classes.table}>
        <TableBody>
          <ResultsTableHeaderRow
            title=""
            values={versions.map((version) => version.name)}
          />
          {purchasedEnergySubCategories.map((subCategory) => (
            <ResultsTableRow
              key={subCategory.nameKey}
              title={`${t(subCategory.nameKey)}, ${largeEmissionPerYearUnit}`}
              values={getValuesForFirstYear([subCategory])}
              formatter={formatLargeEmissionPerYear}
            />
          ))}
          <ResultsTableRow
            title={`${t('common.total')}, ${largeEmissionPerYearUnit}`}
            values={getValuesForFirstYear(purchasedEnergySubCategories)}
            formatter={formatLargeEmissionPerYear}
            highlight
          />
        </TableBody>
      </Table>
    </TableContainer>
  )
}
